export default {
  admin_area_vect_layer: "行政区域矢量图层",
  alarm_end_time: "报警结束时间",
  alarm_information_query_alm_info_qry: "告警信息查询",
  alarm_start_time: "报警开始时间",
  area: "报警区域",
  dev_alarm_source: "设备报警源",
  dev_info_mgmt: "设备信息管理",
  dl_template: "下载模板",
  dm: "设备管理",
  enable: "启用",
  filter_false_alarm: "误报过滤",
  handle_and_push: "处置并推送",
  have: "有",
  lat: "纬度",
  linked_devs: "联动设备",
  loc: "位置",
  lon: "经度",
  lon_lat: "经纬度",
  menu: "菜单",
  nav_to_this_loc: "导航到这",
  playback_history: "回放历史",
  res: "资源",
  resp_person: "责任人",
  res_info_mgmt: "资源信息管理",
  res_name: "资源名称",
  res_type: "资源类型",
  rm: "资源管理",
  show_video: "展示视频",
  tgt_az_angle: "目标方位角度",
  tgt_el_angle: "目标俯仰角度",
  tgt_loc: "目标位置",
  tgt_lon_lat: "目标经纬度",
  tgt_point: "目标点",
  tgt_type: "目标类型",
  times: "次",
  tracking: "切换追踪",
  ves_dest: "船只目的地",
  ves_lon_lat: "船只经纬度",
  ves_name: "船只名称",
  ves_type: "船只类型",
  video_surveillance_alarmvid_sur_alm: "视频监控报警",
};
